import React from "react";
import Modal from "react-bootstrap/Modal";

const WarningModal = (props) => {
  const { handleYes, title, className, ...modalProps } = props;

  return (
    <Modal
      {...modalProps}
      size="md"
      className="modal-container"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="bg-transparent">
        <Modal.Title
          id="contained-modal-title-center"
          className="text-center fw-bold fs-3 mb-1 "
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-gray-700">
          Are you sure you want to delete this item? this item cannot be
          restored
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center bg-transparent px-3 pt-3">
        <button onClick={props.onHide} className="btn btn-secondary px-5">
          No
        </button>
        <button onClick={handleYes} className="btn btn-primary px-5">
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default WarningModal;
